/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { JobOutput } from 'types';
import styled from 'styled-components';
import Collapsible from 'react-collapsible';
import JobListItemHead from './JobListItemHead';
import JobListItemBody from './JobListItemBody';
import { JobCrossMatch } from '../../../types/proccesingJobs';

interface OwnProps {
  jobFiles: JobOutput[];
  jobCrossMatches: JobCrossMatch[];
  remove: (processingJobId: string, documentId: string | undefined) => void;
  refresh: ((processingJobId: string, documentId: string | undefined) => void) | undefined;
}

const JobListItem = styled.div`
  margin-bottom: 10px;
`;

const JobList = ({ jobFiles, jobCrossMatches, remove, refresh }: OwnProps) => {
  const orderedJobFiles = [...jobFiles].reverse();
  const initialCollapseFlags = Object.fromEntries(
    orderedJobFiles.map((output, i) => [i, i === 0 && !output.documentsGroupId]),
  );
  const [collapseFlags, setCollapseFlags] = useState(initialCollapseFlags);

  const toggleCollapse = (index: number) => () => {
    setCollapseFlags((flags) => {
      const flagsCopy = { ...flags };
      flagsCopy[index] = !flagsCopy[index];
      return flagsCopy;
    });
  };

  return (
    <div>
      {orderedJobFiles.length > 0 &&
        orderedJobFiles.map((jobFile, jobIndex) => {
          const { job } = jobFile;
          const filteredCrossMatches = jobCrossMatches.filter(
            (match) => jobFile && jobFile.documentId && match.documentId === jobFile.documentId,
          );
          return (
            <JobListItem key={`job-${jobIndex}`}>
              <JobListItemHead
                jobFile={jobFile}
                crossMatches={filteredCrossMatches}
                collapsed={!collapseFlags[jobIndex]}
                onCollapseClick={toggleCollapse(jobIndex)}
                onRefresh={refresh}
                onRemove={remove}
              />
              {job && job.status === 'succeeded' && (
                <Collapsible trigger='' open={collapseFlags[jobIndex]}>
                  <JobListItemBody job={job} crossMatches={filteredCrossMatches} />
                </Collapsible>
              )}
            </JobListItem>
          );
        })}
    </div>
  );
};

export default React.memo(JobList);
